module.exports = __webpack_public_path__ + "static/media/chevron_up_red.b4122ce6.svg";